export type { InputCardProps } from './InputCard';
export { InputCard } from './InputCard';
